import axios from 'axios';

export function validarnumero(value) {
    const num = /^[0-9]+$/;
    if (!num.test(value)) {
        return 'El campo solo puede contener números';
    }
    return true;
}
export function validarArchivo(value) {    
    return value ? true : 'Este campo es obligatorio para realizar la solicitud';
}

// ESTADOS
let _estados = [];

export async function setEstados() {
    const { data } = await axios.get('api/Estados/Listar');
    _estados = Array.isArray(data) ? data : [];
    return _estados;
}

export function getEstadoN(oid) {
    const id = Number(oid); // por si llega como string
    const item = _estados.find(e => Number(e.oid) === id);
    return item ? item.n_estado : 'Desconocido';
}

// AREAS
let _areas = [];

export async function setAreas() {
    const { data } = await axios.get('api/Areas/Listar');
    _areas = Array.isArray(data) ? data : [];
    return _areas;
}

export function getAreaN(oid) {
    const id = Number(oid); // por si llega como string
    const item = _areas.find(e => Number(e.oid) === id);
    return item ? item.n_area : 'Desconocido';
}

// USUARIOS
let _users = [];

export async function setUsers() {
    const { data } = await axios.get('api/Users/Listar');
    _users = Array.isArray(data) ? data : [];
    return _users;  
}

export function getUserN(oid) {
    const id = Number(oid); // por si llega como string
    const item = _users.find(e => Number(e.oid) === id);
    return item ? item.email : 'Desconocido';
}

// ROL
let _rols = [];

export async function setRols() {
    const { data } = await axios.get('api/Rols/Listar');
    _rols = Array.isArray(data) ? data : [];
    return _rols;  
}

export function getRolN(oid) {
    const id = Number(oid); // por si llega como string
    const item = _rols.find(e => Number(e.oid) === id);
    return item ? item.n_rol : 'Desconocido';
}